// 家戶在畫面上的名稱（SPEC #terms-home-ui-name，Eddy 2026-10-20 選單）：字串表裡的 $t(leaf.cur) 依目前的組織算出來。
//   - 個人組織（或只看得到個人組織）：家庭 / 家庭 / ホーム / Home
//   - team 組織：tree_settings.leaf_label（例「門市」，所有語系都用它）；沒設 = 地點 / 地点 / ロケーション / Location
//   - 範圍是「全部」又有 team 組織：用 team 的預設（地點）
// 英文另有句中小寫與複數：leaf.cur_lc、leaf.cur_pl、leaf.cur_lc_pl；中文、日文四個值相同。組織樹頁自己帶 {{leaf}} 的照它的。
// 寫進字串表的地方在 i18n/index.ts 的 setLeafContext；範圍還沒載入前是 team 預設（地點）。
export type LeafVars = { leaf: string; leaf_lc: string; leaf_pl: string; leaf_lc_pl: string };

type T = (k: string) => string;

/** 某個組織種類 + leaf_label 在目前語系的四個值。 */
export function leafVars(t: T, kind: 'personal' | 'team', label?: string | null): LeafVars {
  const custom = kind === 'team' ? label?.trim() : '';
  if (custom) return { leaf: custom, leaf_lc: custom, leaf_pl: custom, leaf_lc_pl: custom };
  const base = kind === 'personal' ? 'ot.leaf_personal' : 'ot.leaf_default';
  return { leaf: t(base), leaf_lc: t(base + '_lc'), leaf_pl: t(base + '_pl'), leaf_lc_pl: t(base + '_lc_pl') };
}

/** 範圍 → 用哪一種：有指到組織照它；沒指到（全部）時有 team 組織就 team，否則個人。 */
export function leafKind(org: { kind: 'personal' | 'team' } | null | undefined, orgs: { kind: 'personal' | 'team' }[]): 'personal' | 'team' {
  if (org) return org.kind;
  return orgs.some((o) => o.kind === 'team') ? 'team' : 'personal';
}
